/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tags/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HelpAction from './HelpAction/index'
import HelpText from './HelpText/index'
import React from 'react'
import TagsChooser from './TagsChooser/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tags({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Template/Tags"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Tags.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-brs3': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Tags.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Where do you want to use this template?"
 color={dtColorsNeutral900}
 size="normal"
 weight="semibold"
 marginRight={dtSpaceXxs}
/>
<HelpAction
  viewPath={`${viewPath}/HelpAction`}
/>
</div>
<HelpText
  viewPath={`${viewPath}/HelpText`}
/>
<TagsChooser
  viewPath={`${viewPath}/TagsChooser`}
/>
</div>
{children}
</React.Fragment>)
}